import { useStorage } from '@vueuse/core';

type HiddenFilter = 'unhidden-only' | 'all';

export const useVisibleCalculationItems = () => {
  const hiddenFilter = useStorage<HiddenFilter>('calcItemsHidden', 'unhidden-only');

  function toggleHiddenFilter() {
    hiddenFilter.value = hiddenFilter.value === 'unhidden-only' ? 'all' : 'unhidden-only';
  }

  return {
    hiddenFilter,
    toggleHiddenFilter,
  };
};
